import type { VFile } from 'vfile'
import {
  ContainerDirective,
  LeafDirective,
  TextDirective,
} from 'mdast-util-directive'
import type { Element } from 'hast'

function processEmailCard(
  node: TextDirective | LeafDirective | ContainerDirective,
  file: VFile
) {
  const email: string | undefined = node?.attributes?.address

  if (email === undefined) {
    file.fail('email directive: invalid email address', node)
  }

  node.data = node.data ?? {}
  node.data.hName = 'section'
  node.data.hProperties = {
    className: 'sc-email'
  }

  const icon: Element = {
    type: 'element',
    tagName: 'svg',
    properties: {
      className: 'email-card-icon'
    },
    children: []
  }

  const title: Element = {
    type: 'element',
    tagName: 'p',
    properties: {
      className: node.name + '-icon'
    },
    children: [
      {
        type: 'text',
        value: node?.attributes?.title || ''
      }
    ]
  }

  // @ts-ignore
  const directiveContent = node?.children[0].children[0]
  const content: Element = {
    type: 'element',
    tagName: 'p',
    children: [
      {
        type: 'text',
        value: directiveContent.value.replace('%address%', '<a href="mailto:' + email + '">' + email + '</a>')
      }
    ]
  }

  node.data.hChildren = [
    {
      type: 'element',
      tagName: 'div',
      properties: {
        className: node.name + '-title'
      },
      children: [icon, title]
    },
    {
      type: 'element',
      tagName: 'div',
      properties: {
        className: node.name + '-content'
      },
      children: [content]
    }
  ]
}

export default processEmailCard